import { Button } from '@shared/components/ui/button';

interface ErrorStateProps {
  error: Error | unknown;
  onRetry?: () => void;
}

export const ErrorState = ({ error, onRetry }: ErrorStateProps) => {
  const message = error instanceof Error ? error.message : 'Error inesperado';

  return (
    <div className="flex flex-col items-center justify-center h-[calc(100vh-200px)] gap-4">
      <p className="text-sm text-error">{message}</p>
      {onRetry && (
        <Button variant="outline" onClick={onRetry}>
          Reintentar
        </Button>
      )}
    </div>
  );
};
